import React from "react";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { Button, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import SlideUpFadeIn from "../common/animations/SlideUpFadeIn";
import MuiStylesEmptyState from "./MuiStylesEmptyState";

const EmptyState = ({ icon, title, subtitle, buttonLabel, withScheduleInstructions, handleClick, viewPackage }) => {
	const classes = MuiStylesEmptyState();
	const { t } = useTranslation();
	const data = {
		title: title,
		subtitle: subtitle,
		withScheduleInstructions: {
			firstText: withScheduleInstructions?.firstText,
			secondText: withScheduleInstructions?.secondText,
		},
		buttonLabel: buttonLabel,
	};

	return (
		<SlideUpFadeIn style={{ width: "100%", display: "flex", justifyContent: "center" }}>
			<div className={classes.container} style={viewPackage ? { paddingBottom: 0 } : {}}>
				<div className={classes.card} style={viewPackage ? { marginTop: 0, cursor: "default" } : {}}>
					<div className={classes.iconContainer}>
						{icon ? icon : <EventAvailableIcon style={{ fontSize: "3rem" }} className={classes.icon} />}
					</div>
					{title && (
						<div className={classes.titleContainer}>
							<Typography className={classes.title}>{data?.title}</Typography>
						</div>
					)}
					{subtitle && (
						<div className={classes.subtitleContainer}>
							<Typography className={classes.subtitle}>{data?.subtitle}</Typography>
						</div>
					)}
					{withScheduleInstructions && (
						<div>
							<Typography className={classes.instructionsTitle}>{t("How to schedule")}</Typography>
							<ul className={classes.instructionsList}>
								<li>
									<Typography>{data?.withScheduleInstructions?.firstText}</Typography>
								</li>
								<li>
									<Typography>{data?.withScheduleInstructions?.secondText}</Typography>
								</li>
							</ul>
						</div>
					)}
					{buttonLabel && (
						<div className={classes.buttonContainer}>
							<Button onClick={handleClick} className={classes.button}>
								{data?.buttonLabel}
							</Button>
						</div>
					)}
				</div>
			</div>
		</SlideUpFadeIn>
	);
};

export default EmptyState;
